import { ErroGraphicResultsApi } from 'src/service/apis-cockpit';

/**
 * @description
 *
 * Model Base para propriedades comuns
 */
export class ItemMessageBase {

  errorList: ErroGraphicResultsApi[];
}

